import React, { useState, useCallback } from 'react'
import { Container, Navbar, Nav } from 'react-bootstrap'
import { NavLink, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SET_LANGUAGE } from '../constants/langConstants'
import { translations } from '../i18n'

function Header() {
  const dispatch = useDispatch()
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang].nav

  const setLang = (l) => dispatch({ type: SET_LANGUAGE, payload: l })

  const { pathname } = useLocation()
  const isHome = pathname === '/'

  const [expanded, setExpanded] = useState(false)
  const closeMenu = useCallback(() => setExpanded(false), [])

  return (
    <Navbar variant='dark' data-bs-theme='dark' className='fc-navbar' expand='md' sticky='top' expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand as={NavLink} to='/' onClick={closeMenu} className={isHome ? 'fc-brand-home' : ''}>
          Francesco A. Cuzzola
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='fc-nav' aria-label='Toggle navigation' />
        <Navbar.Collapse id='fc-nav'>
          <Nav className='ms-auto align-items-md-center'>
            <Nav.Link as={NavLink} to='/' end onClick={closeMenu}>{T.home}</Nav.Link>
            <Nav.Link as={NavLink} to='/cv/' onClick={closeMenu}>{T.cv}</Nav.Link>
            <Nav.Link as={NavLink} to='/competences/' onClick={closeMenu}>{T.competences}</Nav.Link>
            <Nav.Link as={NavLink} to='/publications/' onClick={closeMenu}>{T.publications}</Nav.Link>
            <Nav.Link as={NavLink} to='/honors/' onClick={closeMenu}>{T.honors}</Nav.Link>
            <Nav.Link as={NavLink} to='/contacts/' onClick={closeMenu}>{T.contacts}</Nav.Link>
            <Nav.Link as={NavLink} to='/blog/' onClick={closeMenu}>{T.blog}</Nav.Link>
            <div className='lang-toggle'>
              <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => setLang('en')}>EN</button>
              <button className={`lang-btn ${lang === 'it' ? 'active' : ''}`} onClick={() => setLang('it')}>IT</button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Header
